export const generateUniqueTimeslotId = (date, nonUniqueSlotId) => {
  return `${date}${nonUniqueSlotId}`;
};
